// extracted by mini-css-extract-plugin
module.exports = {"w1ulamli":"w1ulamli","s17l0384":"s17l0384","rkvwudq":"rkvwudq"};